import type { AnalyticsPlatform } from '@modules/analytics-settings/types/analytics.types';

/** Analytics settings test ids — mirrored in @test-kit INTEGRATIONS.analytics* (keep in sync). */
export const ANALYTICS_SETTINGS_TEST_IDS = {
  addBtn: 'analytics-add-integration-btn',
  addDialog: 'analytics-add-dialog',
  platformCard: (platform: AnalyticsPlatform | string) => `analytics-platform-card-${platform}`,
  addNameInput: 'analytics-add-name-input',
  addBackBtn: 'analytics-add-back-btn',
  addCancelBtn: 'analytics-add-cancel-btn',
  /** `field` is the REQUIRED_CONFIG_FIELDS key (pixelId, measurementId, projectToken, apiKey, accessToken, pixelCode, apiSecret …). */
  editorField: (platform: AnalyticsPlatform | string, field: string) => `analytics-editor-${platform}-${field}`,
  editorSave: (platform: AnalyticsPlatform | string) => `analytics-editor-${platform}-save`,
  cardSwitch: (id: string) => `analytics-integration-switch-${id}`,
  cardEdit: (id: string) => `analytics-integration-edit-${id}`,
  /** "Events sent to Meta" radio group root (FacebookPixelEditor, D3/D5). */
  fbPixelEventMode: 'analytics-fb-pixel-event-mode',
  fbPixelEventModeOption: (mode: 'standard' | 'all') => `analytics-fb-pixel-event-mode-${mode}`,
  /** D5 conflict Alert shown when a sibling Custom Script integration already sends Meta standard events. */
  fbPixelConflictWarning: 'analytics-fb-pixel-conflict-warning',
} as const;
